;(function() {
  'use strict'
  function initScrollHandlers() {
    var elementsQuery = document.querySelectorAll('.scroll-activate')
    var elements = Array.prototype.slice.call(elementsQuery)

    var onVisible = function(element) {
      element.classList.add('activated')
      if (element.classList.contains('scroll-activate--stagger-children')) {
        var staggerChildrenQuery = element.querySelectorAll('.stagger-child')
        var staggerChildren = Array.prototype.slice.call(staggerChildrenQuery)

        var animationBaseDuration = 1
        var childOffsetDuration = 0.15
        if (staggerChildren.length < 4) {
          childOffsetDuration = 0.3
        } else if (staggerChildren.length > 8) {
          childOffsetDuration = 0.1
        }

        staggerChildren.forEach(function(staggerChild, i) {
          staggerChild.style.animationDuration =
            animationBaseDuration + i * childOffsetDuration + 's'
          staggerChild.classList.add('activated')
        })
      }
    }

    var onChange = function(changes, observer) {
      changes.forEach(function(change) {
        if (change.intersectionRatio > 0) {
          onVisible(change.target)
          observer.unobserve(change.target)
        }
      })
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(onChange, {
        rootMargin: '150px 0px 0px 0px',
        // threshold: 0.3,
      })
      elements.forEach(function(element) {
        observer.observe(element)
      })
    } else {
      elements.forEach(function(element) {
        onVisible(element)
      })
    }
  }

  if ('classList' in document.createElement('_')) {
    initScrollHandlers()
  } else {
    console.log('No scroll for IE')
    return
    loadScript('/js/ie-compat.js', function() {
      initScrollHandlers()
    })
  }
})()
